module.exports = __webpack_public_path__ + "img/yan4.2abd6d52.png";